module.exports = __webpack_public_path__ + "assets/media/day34.ea02d486.mp3";